
import { supabase } from "@/lib/supabase";
import { ParentPortalSettings, Organization } from "@/types/organizationTypes";

export const useUpdateParentPortalSettings = (
  organization: Organization | null,
  setOrganization: (org: Organization) => void,
  organizationId?: string
) => {
  return async (settings: ParentPortalSettings) => {
    if (!organizationId || !organization) {
      throw new Error("Organization not loaded");
    }
    const existingSettings = organization.parent_portal_settings || {};

    const updatedSettings = {
      ...existingSettings,
      ...settings,
      features: {
        ...(existingSettings.features || {}),
        ...(settings.features || {}),
      },
      appearance: {
        ...(existingSettings.appearance || {}),
        ...(settings.appearance || {}),
      },
      permissions: {
        ...(existingSettings.permissions || {}),
        ...(settings.permissions || {}),
      },
      notifications: {
        ...(existingSettings.notifications || {}),
        ...(settings.notifications || {}),
      },
    };

    const { error } = await supabase
      .from("organizations")
      .update({ parent_portal_settings: updatedSettings })
      .eq("id", organizationId);

    if (error) {
      throw new Error(error.message);
    }
    setOrganization({ ...organization, parent_portal_settings: updatedSettings });
  };
};
